import React, { useRef } from 'react'
import CircleArrowSVG from 'images/inline/arrow-button.svg'

/*
wrapper our arrow button to prevent double-clicking (which messes up our analytics)

optional className prop is used to add utility classes:
1. to emulate the old button until we can add proper wrappers
2. to rotate it for start slide

*/

const ArrowButton = ({ disabled, onClick, className }) => {
  const buttonRef = useRef()

  // wrapper to prevent double clicking
  const handleClick = event => {
    event.preventDefault()

    if (buttonRef.current) {
      buttonRef.current.setAttribute('disabled', 'disabled')

      setTimeout(() => {
        if (buttonRef && buttonRef.current) {
          buttonRef.current.removeAttribute('disabled')
        }
      }, 2000)
    }

    onClick && onClick()
  }

  return (
    <button
      ref={buttonRef}
      className={`arrow-button2 ${className}`}
      onClick={handleClick}
      disabled={disabled}
      aria-label="Next"
    >
      <CircleArrowSVG />
    </button>
  )
}

export default ArrowButton
